import React, { useState, useCallback } from 'react';
import Navigation from '@/components/site/Navigation';
import Hero from '@/components/site/Hero';
import Countdown from '@/components/site/Countdown';
import About from '@/components/site/About';
import WhyItMatters from '@/components/site/WhyItMatters';
import WorkforceJourney from '@/components/site/WorkforceJourney';
import WhoShouldAttend from '@/components/site/WhoShouldAttend';
import SummitOverview from '@/components/site/SummitOverview';
import Agenda from '@/components/site/Agenda';
import Speakers from '@/components/site/Speakers';
import Sponsorship from '@/components/site/Sponsorship';
import SponsorShowcase from '@/components/site/SponsorShowcase';
import ExhibitorDirectory from '@/components/site/ExhibitorDirectory';
import Gallery from '@/components/site/Gallery';
import MeetOurMedia from '@/components/site/MeetOurMedia';
import MeetOurVolunteers from '@/components/site/MeetOurVolunteers';
import FAQ from '@/components/site/FAQ';
import VenueHotels from '@/components/site/VenueHotels';
import Downloads from '@/components/site/Downloads';
import RegistrationCTA from '@/components/site/RegistrationCTA';
import Contact from '@/components/site/Contact';
import Footer from '@/components/site/Footer';
import InquiryDialog from '@/components/site/InquiryDialog';

const Landing = () => {
  const [dialog, setDialog] = useState({ open: false, type: 'sponsor', prefill: {} });

  const openInquiry = useCallback((type, prefill = {}) => {
    setDialog({ open: true, type, prefill });
  }, []);

  const setOpen = useCallback((open) => {
    setDialog((d) => ({ ...d, open }));
  }, []);

  return (
    <div data-testid="aawta-landing" className="min-h-screen bg-white text-aawta-navy">
      <Navigation />
      <main>
        <Hero />
        <Countdown />
        <About />
        <SummitOverview />
        <Agenda />
        <Speakers />
        <Sponsorship onOpenInquiry={openInquiry} />
        <SponsorShowcase />
        <ExhibitorDirectory onOpenInquiry={openInquiry} />
        <MeetOurMedia />
        <WhyItMatters />
        <WorkforceJourney />
        <WhoShouldAttend />
        <Gallery />
        <MeetOurVolunteers />
        <FAQ />
        <VenueHotels onOpenInquiry={openInquiry} />
        <Downloads />
        <RegistrationCTA />
        <Contact onOpenInquiry={openInquiry} />
      </main>
      <Footer />
      <InquiryDialog
        open={dialog.open}
        onOpenChange={setOpen}
        type={dialog.type}
        prefill={dialog.prefill}
      />
    </div>
  );
};

export default Landing;
